export enum EFileExportTypes {
  NONE,
  XMLSCREEN,
  Text,
}

export enum EFileImportTypes {
  NONE,
  XMLSCREEN,
  TEXT,
}
